import { Component } from '@angular/core';
import { ModalService } from 'src/app/shared/components/modal/modal.service';

@Component({
  selector: 'app-gift-bag-existis-modal',
  templateUrl: './gift-bag-existis-modal.component.html',
  styleUrls: ['./gift-bag-existis-modal.component.scss']
})
export class GiftBagExistisModalComponent {

  constructor(
    private modalService: ModalService
  ) { }

  public onClose(): void {
    this.modalService.closeModal();
  }
}
